import ReactGA from 'react-ga4';

export const gaUtil = {
  pageview(title?: string) {
    ReactGA.send({
      hitType: 'pageview',
      page: window.location.pathname + window.location.search,
      title,
    });
  }
}
